"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackEecPromotionClick = void 0;
const enums_1 = require("../enums");
const trackEecPromotion_1 = require("./trackEecPromotion");
function trackEecPromotionClick(promotion, data) {
    (0, trackEecPromotion_1.trackEecPromotion)(enums_1.EventName.EECPromotionClick, enums_1.GA4EventName.SelectPromotion, [promotion], data);
}
exports.trackEecPromotionClick = trackEecPromotionClick;
//# sourceMappingURL=trackEecPromotionClick.js.map